module.exports = __webpack_public_path__ + "img/nongji.5216ad6b.png";